import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import Menu from './menu.jsx';
import ElementLibrary from '../element/library/ElementLibrary';
import ZendeskLibrary from '../element/zendesk/ZendeskLibrary';

class AddNewElement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      menuStyle: {},
      viewElementLibrary: false,
      viewZendeskLibrary: false,
    };
    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.setRef = this.setRef.bind(this);
    this.showElementLibrary = this.showElementLibrary.bind(this);
    this.closeElementLibrary = this.closeElementLibrary.bind(this);
    this.showZendeskLibrary = this.showZendeskLibrary.bind(this);
    this.closeZendeskLibrary = this.closeZendeskLibrary.bind(this);
  }

  createElement(type) {
    this.setState({ active: false }, () => {
      this.props.onCreate(type, this.props.position);
      this.closeMenu(null, true);
    });
  }

  closeMenu(evt, forceClose) {
    const { menuKeepOpen } = this.state;
    if (!menuKeepOpen && (forceClose || !this.container.contains(evt.target))) {
      this.setState({ active: false }, () => {
        this.resetPosition();
        window.removeEventListener('click', this.closeMenu);
      });
    }
  }

  updateMenuPosition({ clientX, clientY }) {
    const { menu } = this.menu.refs;
    const containerRect = this.container.getBoundingClientRect();
    const [xShift, yShift] = [30, 10];
    const newPosition = {};

    newPosition.top = clientY - containerRect.top + yShift;
    newPosition.right = Math.max(
      0,
      containerRect.right - clientX - menu.offsetWidth + xShift,
    );

    // @TODO make this look better
    if (window.innerWidth < 1335 && newPosition.right === 0) {
      newPosition.right += 110;
      newPosition.top = 10;
    }

    if (
      window.innerHeight - clientY < menu.offsetHeight &&
      clientY > menu.offsetHeight
    ) {
      newPosition.bottom = containerRect.bottom - clientY - yShift;
      delete newPosition.top;
    }

    this.setMenuPosition(newPosition);
  }

  setMenuPosition({ top, right, bottom }) {
    this.setState({
      menuStyle: {
        top: top && `${top}px`,
        right: right && `${right}px`,
        bottom: bottom && `${bottom}px`,
      },
    });
  }

  resetPosition() {
    this.setState({ menuStyle: null });
  }

  setRef(ref, key) {
    this[key] = ref;
  }

  showMenu(e) {
    e.persist(); // disable event pooling
    if (!this.state.active) {
      this.setState({ active: true }, () => {
        this.updateMenuPosition(e);
        window.addEventListener('click', this.closeMenu);
      });
    } else if (e.target !== this.menu.refs.menu) {
      this.updateMenuPosition(e);
    }
  }

  showElementLibrary() {
    this.setState({ viewElementLibrary: true });
    this.closeMenu(null, true);
  }

  closeElementLibrary() {
    this.setState({ viewElementLibrary: false });
  }

  showZendeskLibrary() {
    this.setState({ viewZendeskLibrary: true });
    this.closeMenu(null, true);
  }

  closeZendeskLibrary() {
    this.setState({ viewZendeskLibrary: false });
  }

  setMenuKeepOpen = value => {
    this.setState({
      menuKeepOpen: value,
    });
  };

  render() {
    const { isOver, connectDropTarget, canDrop } = this.props;
    const isHovering = isOver && canDrop;

    return connectDropTarget(
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div
        className="EditorElement-addSiblingContainer"
        onClick={this.showMenu}
      >
        <div
          ref={node => this.setRef(node, 'container')}
          className={`AddSibling ${
            this.state.active || isHovering ? 'active' : ''
          }`}
        >
          <div className="AddSibling-addButton">
            <Icon name="add" />
            <div className="AddSibling-addButtonLabel">
              <div>{isHovering ? 'Move Element Here' : 'Add Element'}</div>
            </div>
          </div>
          <Menu
            visible={this.state.active}
            setRef={this.setRef}
            style={this.state.menuStyle}
            optionClickCallback={type => this.createElement(type)}
            showElementLibrary={this.showElementLibrary}
            showZendeskLibrary={this.showZendeskLibrary}
            setMenuKeepOpen={this.setMenuKeepOpen}
          />
          {this.state.viewElementLibrary && (
            <ElementLibrary
              closeElementLibrary={this.closeElementLibrary}
              position={this.props.position}
            />
          )}
          {this.state.viewZendeskLibrary && (
            <ZendeskLibrary
              closeZendeskLibrary={this.closeZendeskLibrary}
              position={this.props.position}
            />
          )}
        </div>
      </div>,
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.editor.i18n,
});

export default connect(mapStateToProps)(AddNewElement);
